import { Flex } from 'foundations-components/components/Flex';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { AILoader } from 'ai-components-ui-library/components/loading/AILoader';
import { useBreeze } from '../../contexts/BreezeContext';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { useExperiment, TrackWhen } from '../../experiments/useExperiment';
import { useGTKMDomainHelperTextKey } from '../../hooks/useGTKMDomainHelperText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SidePanelCompanyDomainLoading = () => {
  const {
    copyKey,
    isRunning,
    showLoadingState
  } = useBreeze();
  const {
    isGTKMAnimationRunning,
    copyMessageKey
  } = useGTKMDomainHelperTextKey();
  const {
    isAssignedToSpecificVariant: isAssignedToACQ172Variant
  } = useExperiment(ExperimentKeys.ACQ0172, TrackWhen.never);
  const isAssignedToACQ172VariantB = isAssignedToACQ172Variant(ExperimentParameterGroup.Variant_B);
  const {
    isAssignedToSpecificVariant: isAssignedToACQ173Variant
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.never);
  const isAssignedToACQ173VariantA = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToACQ173VariantC = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_C);
  const isAssignedToACQ173VariantAorC = isAssignedToACQ173VariantA || isAssignedToACQ173VariantC;
  const notAssignedToSpecificExperiment = !isAssignedToACQ172VariantB && !isAssignedToACQ173VariantA && !isAssignedToACQ173VariantC;
  const AnimationNotLoadedForACQ172VariantB = isAssignedToACQ172VariantB && !showLoadingState;
  const AnimationNotLoadedForACQ173VariantA = isAssignedToACQ173VariantAorC && !isGTKMAnimationRunning;
  if (notAssignedToSpecificExperiment || AnimationNotLoadedForACQ172VariantB || AnimationNotLoadedForACQ173VariantA) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "company-domain-footer",
    gap: "100",
    justifyContent: "center",
    marginBlockEnd: "auto",
    marginBlockStart: "auto",
    marginInlineEnd: "400",
    children: [/*#__PURE__*/_jsx(AILoader, {
      isFinished: isAssignedToACQ173VariantAorC ? !isGTKMAnimationRunning : !isRunning,
      size: "xs"
    }), /*#__PURE__*/_jsx(Text, {
      as: "small",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: isAssignedToACQ173VariantAorC ? copyMessageKey : copyKey
      })
    })]
  });
};
export default SidePanelCompanyDomainLoading;